import styled from '@emotion/styled'
import VerticalBar from '../../common/VerticalBar'
import { Info, SubTitle } from './styled'

const OptionTitle = styled(SubTitle)`
  margin-bottom: 0;
`

const Container = styled.div`
  align-items: center;
  margin-bottom: 0.4rem;
`
const Caption = styled(Info)`
  display: inline-block;
`

interface ILeisureOptionTitleProps {
  data: { title: string; caption?: string }
}

const LeisureOptionTitle: React.FC<ILeisureOptionTitleProps> = ({ data }) => {
  return (
    <Container>
      <OptionTitle>{data.title}</OptionTitle>
      {data.caption && (
        <>
          <VerticalBar>|</VerticalBar>
          <Caption>{data.caption}</Caption>
        </>
      )}
    </Container>
  )
}

export default LeisureOptionTitle
